import { Stack } from "@mui/material";
import StatCard from "./StatCard";
import StatDescription from "./StatDescription";
import Stat from "./Stat";

export default function CampaignManagerStats({ data }) {
  const summaryCards = data;
  return (
    <Stack
      spacing={4}
      direction="row"
      sx={{
        overflowX: "auto",
      }}
    >
      <StatCard
        statDescription={
          <StatDescription
            width="60px"
            height="60px"
            description="Presupuesto Mensual:"
            maxWidth="200px"
          />
        }
        stat={
          <Stat
            stat={summaryCards?.monthlyBudget?.value}
            currency={summaryCards?.monthlyBudget?.currency}
          />
        }
        statLabel={summaryCards?.monthlyBudget?.performance}
        comparisonPeriod={summaryCards?.monthlyBudget?.comparisonPeriod}
      />
      <StatCard
        statDescription={
          <StatDescription
            width="60px"
            height="60px"
            description="Gasto Actual:"
            maxWidth="200px"
          />
        }
        stat={
          <Stat
            stat={summaryCards?.actualSpend?.value}
            currency={summaryCards?.actualSpend?.currency}
          />
        }
        statLabel={summaryCards?.actualSpend?.performance}
        comparisonPeriod={summaryCards?.actualSpend?.comparisonPeriod}
      />
      <StatCard
        statDescription={
          <StatDescription
            width="60px"
            height="60px"
            description="Estado de consumo:"
            maxWidth="200px"
          />
        }
        stat={<Stat stat={summaryCards?.consumptionStatus?.value} projected />}
        statLabel={summaryCards?.consumptionStatus?.status}
      />
      <StatCard
        statDescription={
          <StatDescription
            width="60px"
            height="60px"
            description="Campañas Activas:"
            maxWidth="200px"
          />
        }
        stat={<Stat stat={summaryCards?.activeCampaigns?.count} />}
        statLabel={summaryCards?.activeCampaigns?.performance}
        comparisonPeriod={summaryCards?.activeCampaigns?.comparisonPeriod}
      />
    </Stack>
  );
}
